// Components
import Drawer from "@mui/material/Drawer";
import TimelineSidebar from "../TimelineSidebar";

// Types
import { PatientType } from "src/services/patients/types";

type TimelineDrawerType = {
  isOpen: boolean;
  onClose: () => void;
  selectedPatient: PatientType;
};

// Mobile-only drawer for timeline sidebar
const TimelineDrawer = ({
  isOpen,
  onClose,
  selectedPatient,
}: TimelineDrawerType) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      disableRestoreFocus
      // Add to zIndex so it appears above the modal
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          width: { xs: "100vw", sm: "350px" },
        },
      }}
    >
      <TimelineSidebar
        selectedPatient={selectedPatient}
        isCollapsed={false}
        onToggleCollapse={onClose}
      />
    </Drawer>
  );
};

export default TimelineDrawer;
